import * as actionTypes from '../actions/ActionTypes';
import * as api from '../../shared/services/api/apiSimulatedTest';

import { all, put, takeEvery } from 'redux-saga/effects';

import { Logout, setSimulatedQuestionByTopicId, startLoading, stopLoading } from '../actions';
// import { setSimulatedQuestionByTopicId } from "../actions/SimulatedTestActions";
import {
  OFFLINE_USER,
  SESSION_EXPIRED,
  SESSION_EXPIRED_CODE,
  SOMETHING_WRONG,
} from '../../shared/constants/Constants';

import { checkOffline } from '../../shared/services/Utility';

const delay = (ms) =>
  new Promise((res) => {
    setTimeout(res, ms);
  });

function* OnShowSimulatedTest(action) {
  try {
    yield put(startLoading());
    const data = yield api.fetchQuestionsForSimulatedTest(action.questionBody);

    if (data.status === 1) {
      /* test time */
      const testTime = data.examTime;
      /* create questions array */
      const tempData = data.simulatedData;

      const finalSimulatedTestResult = [
        ...tempData.catID_1,
        ...tempData.catID_3,
        ...tempData.catID_5,
        ...tempData.catID_6,
        ...tempData.catID_7,
        // ...tempData.catID_1.slice(0, 1),
        // ...tempData.catID_3.slice(0, 1),
        // ...tempData.catID_5.slice(0, 1),
        // ...tempData.catID_6.slice(0, 1),
        // ...tempData.catID_7.slice(0, 1),
      ];

      /* create number of questions array */
      const numberOfQuestionsInEachCategory = {
        catID_1: tempData.catID_1.length,
        catID_3: tempData.catID_3.length,
        catID_5: tempData.catID_5.length,
        catID_6: tempData.catID_6.length,
        catID_7: tempData.catID_7.length,
        // catID_1: 1,
        // catID_3: 1,
        // catID_5: 1,
        // catID_6: 1,
        // catID_7: 1,
      };

      yield put(
        setSimulatedQuestionByTopicId(
          finalSimulatedTestResult,
          numberOfQuestionsInEachCategory,
          testTime,
        ),
      );
      action.callback('', 'success');
      //   yield put(goto_simulatedTest());
    } else if (data.status === SESSION_EXPIRED_CODE) {
      //   /*session id expired*/
      action.callback(SESSION_EXPIRED, 'error');
      yield put(Logout());
    } else {
      const tempData = {
        catID_1: [
          {
            id: '6',
            topic_id: '1',
            subTopicId: '13',
            question:
              'Which international law opened for signature on 3 June 2013?',
            ans1: 'Arms Trade Treaty',
            ans2: 'Banana Trade Treaty',
            ans3: 'Candle Trade Treaty',
            ans4: 'Apple Trade Treaty',
            correctAnswer: 'Arms Trade Treaty',
            matchup_answers: '',
            answerDescription:
              'International law opened for signature on 3 June 2013 - Arms Trade Treaty',
            incorrectDescription: '',
            deleteStatus: '0',
            question_type: '0',
            createdDate: '2018-04-16 17:39:29',
          },
        ],
        catID_3: [
          {
            id: '6',
            topic_id: '1',
            subTopicId: '13',
            question:
              'Which international law opened for signature on 3 June 2013?',
            ans1: 'Arms Trade Treaty',
            ans2: 'Banana Trade Treaty',
            ans3: 'Candle Trade Treaty',
            ans4: 'Apple Trade Treaty',
            correctAnswer: 'Arms Trade Treaty',
            matchup_answers: '',
            answerDescription:
              'International law opened for signature on 3 June 2013 - Arms Trade Treaty',
            incorrectDescription: '',
            deleteStatus: '0',
            question_type: '0',
            createdDate: '2018-04-16 17:39:29',
          },
        ],
        catID_5: [
          {
            id: '6',
            topic_id: '1',
            subTopicId: '13',
            question:
              'Which international law opened for signature on 3 June 2013?',
            ans1: 'Arms Trade Treaty',
            ans2: 'Banana Trade Treaty',
            ans3: 'Candle Trade Treaty',
            ans4: 'Apple Trade Treaty',
            correctAnswer: 'Arms Trade Treaty',
            matchup_answers: '',
            answerDescription:
              'International law opened for signature on 3 June 2013 - Arms Trade Treaty',
            incorrectDescription: '',
            deleteStatus: '0',
            question_type: '0',
            createdDate: '2018-04-16 17:39:29',
          },
        ],
        catID_6: [
          {
            id: '6',
            topic_id: '1',
            subTopicId: '13',
            question:
              'Which international law opened for signature on 3 June 2013?',
            ans1: 'Arms Trade Treaty',
            ans2: 'Banana Trade Treaty',
            ans3: 'Candle Trade Treaty',
            ans4: 'Apple Trade Treaty',
            correctAnswer: 'Arms Trade Treaty',
            matchup_answers: '',
            answerDescription:
              'International law opened for signature on 3 June 2013 - Arms Trade Treaty',
            incorrectDescription: '',
            deleteStatus: '0',
            question_type: '0',
            createdDate: '2018-04-16 17:39:29',
          },
        ],
        catID_7: [
          {
            id: '6',
            topic_id: '1',
            subTopicId: '13',
            question:
              'Which international law opened for signature on 3 June 2013?',
            ans1: 'Arms Trade Treaty',
            ans2: 'Banana Trade Treaty',
            ans3: 'Candle Trade Treaty',
            ans4: 'Apple Trade Treaty',
            correctAnswer: 'Arms Trade Treaty',
            matchup_answers: '',
            answerDescription:
              'International law opened for signature on 3 June 2013 - Arms Trade Treaty',
            incorrectDescription: '',
            deleteStatus: '0',
            question_type: '0',
            createdDate: '2018-04-16 17:39:29',
          },
        ],
      };
      const finalSimulatedTestResult = [
        ...tempData.catID_1,
        ...tempData.catID_3,
        ...tempData.catID_5,
        ...tempData.catID_6,
        ...tempData.catID_7,
      ];

      const numberOfQuestionsInEachCategory = {
        catID_1: 5,
        catID_3: 5,
        catID_5: 5,
        catID_6: 5,
        catID_7: 5,
      };
      yield put(
        setSimulatedQuestionByTopicId(
          finalSimulatedTestResult,
          numberOfQuestionsInEachCategory,
        ),
      );

      action.callback('', 'success');
    }
    yield put(stopLoading());
  } catch (e) {
    // alert('error ==  ' + e)
    yield put(stopLoading());
    if (checkOffline()) {
      action.callback(OFFLINE_USER, 'error');
    } else {
      action.callback(SOMETHING_WRONG, 'error');
    }
  }
}

function* submitSimulatedTestResult(action) {

  try {
    yield put(startLoading());
    const data = yield api.submitSimulatedTestResult(
      action.simulated_test_score_body,
    );

    //yield put(dashboardTestResultFetch(action.dashboardFetch));
    if (data.status === 1) {
      action.success();
      // action.callback("Result Sent to email", "success");
    } else if (data.status === SESSION_EXPIRED_CODE) {
      /*session id expired*/
      yield put(stopLoading());
      action.callback(SESSION_EXPIRED, 'error');
      yield put(Logout());
    } else {
      yield put(stopLoading());
      yield delay(1000);
      action.callback('Problem in sending', 'error');
    }
    yield put(stopLoading());
  } catch (e) {
    yield put(stopLoading());
    if (checkOffline()) {
      action.callback(OFFLINE_USER, 'error');
    } else {
      action.callback(SOMETHING_WRONG, 'error');
    }
  }
}

// function* fetchChallengeHistoryList(action) {
//   try {
//     let res = yield fetchChallengeHistoryListAPI(action.params);
//     // alert(JSON.stringify(res))
//     if (res.status === 1 || res.status === 200) {
//       //data fetched
//       // alert(res.data)
//       yield put(updateChallengeHistoryList(res.data));
//     } else if (data.status === SESSION_EXPIRED_CODE) {
//       /*session id expired*/
//       if (!Utility.isAlertShowing) {
//         Utility.updateAlertShowing(true);
//         Alert.alert(APP_NAME, SESSION_EXPIRED, [
//           {
//             text: "OK",
//             onPress: () => {
//               Utility.updateAlertShowing(false);
//             },
//           },
//         ]);
//         yield put(Logout());
//         // yield put(goto_login())
//       }
//     }
//   } catch (e) {
//     // alert('error')
//   }
// }

/*************************** */

function* submitChallengeRequest(action) {

  try {
    const data = yield api.submitChallengeRequestAPI(action.body);

    if (data.status === 200) {
      action.callback(
        'Challenge request successfully sent to user.',
        'success',
      );
    } else if (data.status === SESSION_EXPIRED_CODE) {
      /*session id expired*/
      yield put(stopLoading());
      action.callback(SESSION_EXPIRED, 'error');
      yield put(Logout());
    } else if (data.status === 0) {
      yield put(stopLoading());
      yield delay(1000);
      action.callback('Score must be greater than 0 to send challenge', 'error');
    } else {
      yield put(stopLoading());
      yield delay(1000);
      action.callback('Problem in sending', 'error');
    }
  } catch (e) {

    yield put(stopLoading());
    if (checkOffline()) {
      action.callback(OFFLINE_USER, 'error');
    } else {
      action.callback(SOMETHING_WRONG, 'error');
    }
  }
}

function* submitChallengeHistory(action) {
  try {
    const data = yield api.submitChallengeHistoryAPI(action.body);
    if (data.status === 200) {
      // alert('challenge history submitted')
    } else if (data.status === SESSION_EXPIRED_CODE) {
      yield put(stopLoading());
      action.callback(SESSION_EXPIRED, 'error');
      yield put(Logout());
    }
  } catch (e) {
    yield put(stopLoading());
    if (checkOffline()) {
      action.callback(OFFLINE_USER, 'error');
    } else {
      action.callback(SOMETHING_WRONG, 'error');
    }
  }
}

function* submitSimulatedTestSaga() {
  yield all([
    yield all([
      takeEvery(actionTypes.GOTO_SIMULATED_TEST, OnShowSimulatedTest),
    ]),
    takeEvery(
      actionTypes.SUBMIT_SIMULATED_TEST_RESULT,
      submitSimulatedTestResult,
    ),
    takeEvery(actionTypes.SUBMIT_CHALLENGE_REQUEST, submitChallengeRequest),
    takeEvery(actionTypes.SUBMIT_CHALLENGE_HISTORY, submitChallengeHistory),

    // takeEvery(
    //   actionTypes.FETCH_CHALLENGE_HISTORY_LIST,
    //   fetchChallengeHistoryList
    // ),
  ]);
}

export default submitSimulatedTestSaga;
